module.exports = __webpack_public_path__ + "static/media/kathari.d4e34958.svg";